import React, { useContext } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import UserService from "services/UserService";
import { getArchitecture } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function DelGroupDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleSubmit = async (event) => {
    axios
      .delete(
        getArchitecture(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          let parentid = "" + res.data.parentid;
          NotificationManager.success("Groupe supprimé");
          props.closeModal();
          props.handleSubmitSuccess(parentid);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>

        <DialogContent>
          <DialogContentText style={{ color: "black" }}>
            {"Attention, cette action supprimera le groupe et tous les groupes fils."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.closeModal}
            noWrap
            style={{
              color: "#FFFFFF",
              backgroundColor: "#9798A0",
              fontWeight: "normal",
              fontWeight: "bold",
              height: "40px",
              fontSize: "0.75rem",
              padding: "5px 15px",
              marginRight: "0px",
              marginBottom: "0px",
              marginTop: "15px",
              fontFamily: '"Source Sans Pro",sans-serif',
              width: "30%",
              marginLeft: "2%",
            }}>
            Annuler
          </Button>
          <Button
            noWrap
            style={{
              color: "#FFFFFF",
              backgroundColor: "#f44336",
              fontWeight: "normal",
              fontWeight: "bold",
              height: "40px",
              fontSize: "0.75rem",
              padding: "5px 15px",
              marginRight: "0px",
              marginBottom: "0px",
              marginTop: "15px",
              fontFamily: '"Source Sans Pro",sans-serif',
              width: "30%",
              marginLeft: "2%",
            }}
            onClick={() => {
              handleSubmit();
            }}
          >
            Supprimer
          </Button>
        </DialogActions>

      </form>
    </div>
  );
}

export default DelGroupDialog;
